import {Enum} from "~/enums/index";

export default new Enum({
    JOB: "JOB",
    CANDIDATE: "CANDIDATE",
});
